const HANGUPS = {
    bot: { icon: 'fa-robot', label: 'Bot', title: 'The bot hung up' },
    human: { icon: 'fa-user', label: 'Human', title: 'The caller hung up' },
    transfer: { icon: 'fa-exchange-alt', label: 'Transfer', title: 'The call was transferred: who hung up is unknown' },
    error: { icon: 'fa-exclamation-triangle', label: 'Error', title: 'The call was closed because of an error on the bot side' },
};

const getHangup = ({ hangup_by } = {}) => HANGUPS[hangup_by] ? { by: hangup_by, ...HANGUPS[hangup_by] } : null;

export default getHangup;
